 <template>
  <div class="d-flex flex-column justify-content-center">
    <div
      class="steps"
      :class="{'five-steps': userFromTokenIsRegularOrAdmin && userFromTokenHasCards}"
    >
      <template v-for="(step,index) in currentOnboardingSteps">
        <div
          class="step"
          :id="step.internalId"
          @click="goStep(step.id)"
          :class="classForStep(step.id)"
          :key="step.internalId"
        >
          {{ step.step }}
        </div>
        <div
          class="step-separator"
          :id="step.internalId"
          :class="classForStep(step.id +1)"
          :key="step.separatorId"
          v-if="index !== currentOnboardingSteps.length -1"
        ></div>
      </template>
      <!--
      <div
        class="step"
        @click="goPreviousStep(1)"
        :class="classForStep(1)"
      >1</div>
      <div
        v-if="userFromTokenHasCards"
        class="step-separator"
        :class="classForStep(2)"
      ></div>
      <div
        class="step"
        @click="goPreviousStep(2)"
        :class="classForStep(2)"
        v-if="userFromTokenHasCards"
      >2</div>
      <div
        class="step-separator"
        :class="classForStep(3)"
      ></div>
      <div
        class="step"
        @click="goPreviousStep(3)"
        :class="classForStep(3)"
      >
        <template v-if="userFromTokenHasCards">3</template>
        <template v-else>2</template>

      </div>
      <div
        v-if="userFromTokenIsRegularOrAdmin && userFromTokenHasCards && !userHasVirtualCards && userHasShippingAddressEnabled"
        class="step-separator"
        :class="classForStep(4)"
      ></div>
      <div
      v-if="userFromTokenIsRegularOrAdmin && userFromTokenHasCards && !userHasVirtualCards && userHasShippingAddressEnabled"
        class="step"
        :class="classForStep(4)"
      >4</div>
      <div
        class="step-separator"
        :class="classForStep(5)"
      ></div>
      <div
        class="step"
        :class="classForStep(5)"
      >
        <template v-if="userFromTokenHasCards && !userHasVirtualCards && userHasShippingAddressEnabled">

          <template v-if="userFromTokenIsRegularOrAdmin">5</template>

          <template v-else>4</template>
        </template>
        <template v-else-if="!userFromTokenHasCards">3</template>
        <template v-else-if="userHasVirtualCards || !userHasShippingAddressEnabled">4</template>

      </div>
       -->
    </div>
    <form
      class="Form Invitation-form Login-form--accept-invitation mb-a"
      id="signup"
      autocomplete="on"
      @submit.prevent="acceptInvitation"
    >

      <div class="step-content">
        <div v-if="isActiveStep(1)">
          <h1
            class="Tit Tit--login my-3 text-center pb-3"
            v-t="{path : 'user_invitation_form_complete_registration'}"
          ></h1>

          <div class="form-fields">
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="firstNameInput"
                class="form--label u-required"
              >{{$t('FIRST_NAME').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.firstName.$error}"
                v-focus-input
              >
                <input
                  type="text"
                  id="firstNameInput"
                  :placeholder="$t('FIRST_NAME')"
                  :disabled="isAccountHolder"
                  class="Input-text"
                  v-model.trim="firstName"
                  @blur="$v.firstName.$touch()"
                />
              </div>
            </div>

            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="lastNameInput"
                class="form--label u-required"
              >{{$t('LAST_NAME').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.lastName.$error}"
                v-focus-input
              >
                <input
                  type="text"
                  id="lastNameInput"
                  :placeholder="$t('LAST_NAME')"
                  :disabled="isAccountHolder"
                  class="Input-text"
                  v-model.trim="lastName"
                  @blur="$v.lastName.$touch()"
                />
              </div>
            </div>
              <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded mb-3">
              <label
                for="date-of-birth"
                class="form--label u-required"
              >{{$t('DATE_OF_BIRTH').toUpperCase()}}</label>
                  <date-picker-input
                  :mode="'date'"
                  :placeholder="'DATE_OF_BIRTH'"
                  :value="userDateOfBirth"
                  @inputDate="setUserDateOfBirth($event)"
                />

            </div>

            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="country"
                class="form--label u-required"
              >{{$t('COUNTRY').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.userCountry.$error}"
                v-focus-input
              >
                <template v-if="phonePrefixList.length > 0">
                  <input-select
                    :dataCollection="countryNationalityList"
                    :defaultSelected="'ES'"
                    :fieldForDefaultSelected="'isoCode'"
                    :label="'name'"
                    :placeholder="$t('COUNTRY')"
                    @input="setField('userCountry', $event)"
                  ></input-select>
                </template>
              </div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded mb-3">
              <label
                for="password"
                class="form--label u-required"
              >{{$t('PASSWORD').toUpperCase()}}</label>
              <div
                class="Form-field required"
                :class="{'Form--field-error' :$v.password.$error}"
                v-focus-input
              >
                <input
                  class="Input-text"
                  type="password"
                  autocomplete="new-password"
                  @blur="$v.password.$touch()"
                  :placeholder="$t('PASSWORD')"
                  v-model="password"
                  maxlength="48"
                />
              </div>
            </div>

            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="name"
                class="form--label u-required"
              >{{$t('REPEAT_PASSWORD').toUpperCase()}}</label>
              <div
                class="Form-field required"
                :class="{'Form--field-error': !$v.repeatPassword.sameAsPassword && $v.repeatPassword.$dirty }"
                v-focus-input
              >
                <input
                  class="Input-text"
                  type="password"
                  autocomplete="new-password"
                  @blur="$v.repeatPassword.$touch()"
                  :placeholder="$t('REPEAT_PASSWORD')"
                  v-model="repeatPassword"
                  maxlength="48"
                />
              </div>
            </div>

            <span v-if="!$v.repeatPassword.sameAsPassword && $v.repeatPassword.$dirty">
              <p
                class="validation-error password--mismatch-text status--red"
                v-t="{path: 'validations_password_mismatch'}"
              ></p>
            </span>

            <div class="d-flex justify-content-between w-100 input--block--padded">
              <div class="input--block input--block--smaller input--block--prefix w-25">
                <label
                  for="name"
                  class="form--label u-required"
                >{{$t('PHONE_PREFIX').toUpperCase()}}</label>
                <div class="Form-field">
                  <template v-if="phonePrefixList.length > 0">
                    <input-select
                      :dataCollection="phonePrefixList"
                      :defaultSelected="'ES'"
                      :fieldForDefaultSelected="'isoCode'"
                      ignoreItemTranslation
                      :label="'phonePrefix'"
                      :placeholder="$t('PHONE_PREFIX')"
                      @input="setField('userPhonePrefix', $event)"
                    ></input-select>
                  </template>
                </div>
              </div>

              <div
                class="input--block ml-2 input--block--smaller input--block--phone required width-70"
                v-focus-input
              >
                <label
                  for="phone"
                  class="form--label u-required"
                >{{$t('MOBILE_PHONE_NUMBER').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error' : $v.userPhone.$error}"
                >
                  <input
                    class="Input-text"
                    type="text"
                    @blur="$v.userPhone.$touch()"
                    :placeholder="$t('MOBILE_PHONE_NUMBER')"
                    v-model="userPhone"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex input--block--padded">
              <p
                class="p--sub"
                v-t="{path: 'user_invitation_form_email_no_spam'}"
              >
              </p>

            </div>

            <div class="d-flex flex-column w-100">
              <div class="p-1 mt-1">
                <button
                  class="Button Button--primary w-100"
                  :disabled="!canContinue"
                  @click.prevent="goStep(2)"
                  type="button"
                >
                  <span
                    class="Button-lit"
                    v-t="{ path: 'ACTION_CONTINUE'}"
                  ></span>
                </button>
              </div>
            </div>
          </div>
          <div class="text-center py-2">
            <span class="u-gray u-textMin">
              {{$t('login_already_a_user_redirect')}}
              <a
                href="#"
                rel=noopener
                @click.prevent="pushSignin"
                class="u-blue"
              >{{$t('login_already_a_user_redirect_login_link')}}</a>
            </span>
          </div>
        </div>

        <div v-if="isActiveStep(2)">
          <h1
            class="Tit Tit--login my-3 text-center pb-3"
            v-t="{path : 'user_invitation_form_identification'}"
          ></h1>
          <div class="form-fields">
            <div class="input--block input--block--margin input--block--padded mb-3">
              <label
                for="name"
                class="form--label u-required"
              >{{$t('user_invitation_form_id').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.userDocument.$error}"
              >
                <input-facade
                  class="Input-text"
                  v-model="userDocument"
                  :placeholder="$t('user_invitation_form_id')"
                  :mask="countryDocumentMask"
                  @blur="$v.userDocument.$touch()"
                ></input-facade>
              </div>
            </div>
            <template>
              <div class="input--block input--block--margin input--block--padded mb-2">
                <label class="form--label u-required">{{$t('user_invitation_form_dni_expiration_date').toUpperCase()}}</label>
                <div
                  class='Form-field required'
                  :class="{'Form--field-error' : $v.userDocumentExpirationDate.$error}"
                >
                  <input-facade
                    class='Input-text'
                    :placeholder="$t('user_invitation_form_select_expiration_date')"
                    masked
                    v-model="userDocumentExpirationDate"
                    @blur="$v.userDocumentExpirationDate.$touch()"
                    mask="##/##/####"
                  ></input-facade>
                </div>
              </div>
              <small
                class="text-danger ml-1"
                v-if="$v.userDocumentExpirationDate.$error"
              >{{$t('date_invalid_error')}}</small>
            </template>

            <div class="d-flex flex-column w-100">
              <div class="p-1 mt-1">
                <button
                  class="Button Button--primary w-100"
                  :disabled="!canContinue"
                  @click.prevent="goStep(3)"
                  type="button"
                >
                  <span
                    class="Button-lit"
                    v-t="{ path: 'ACTION_CONTINUE'}"
                  ></span>
                </button>
              </div>
            </div>
          </div>
          <div class="text-center py-2">
            <span class="u-gray u-textMin">
              {{$t('login_already_a_user_redirect')}}
              <a
                href="#"
                @click.prevent="pushSignin"
                rel="noopener"
                class="u-blue"
              >{{$t('login_already_a_user_redirect_login_link')}}</a>
            </span>
          </div>
        </div>
        <div v-if="isActiveStep(3)">
          <div class="form-fields">
            <h1
              class="Tit Tit--login mt-3 mb-2 pb-1 text-center"
              v-t="{path : 'user_invitation_form_create_passcode', args : { name: userInvitationData.firstName, digits: 4 }}"
            ></h1>
            <p class="p--tip text-center">
              <strong v-t="{path: 'user_invitation_form_create_passcode_not_card_pin'}"></strong>&nbsp;
              <span v-t="{path: 'user_invitation_form_create_passcode_text'}"></span>
            </p>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="passcode"
                class="form--label"
              >{{$t('user_self_onboarding_passcode').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.userPasscode.$error}"
                v-focus-input
              >
                <input
                  type="password"
                  v-model.trim="userPasscode"
                  class="Input-text"
                  :placeholder="$t('user_self_onboarding_passcode_placeholder')"
                  maxlength="4"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  @keydown="handleKeyDown"
                  @blur="$v.userPasscode.$touch()"
                />
              </div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="repeat-passcode"
                class="form--label"
              >{{$t('user_self_onboarding_repeat_passcode').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.userPasscodeRepeat.$error}"
                v-focus-input
              >
                <input
                  type="password"
                  v-model.trim="userPasscodeRepeat"
                  class="Input-text"
                  :placeholder="$t('user_self_onboarding_repeat_passcode_placeholder')"
                  maxlength="4"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  @keydown="handleKeyDown"
                  @blur="$v.userPasscodeRepeat.$touch()"
                />
              </div>
            </div>
            <button
              class="Button Button--primary w-100"
              :disabled="userPasscode !== userPasscodeRepeat || ($v.userPasscode.$invalid || $v.userPasscodeRepeat.$invalid)"
              @click.prevent="handlePasscodeRepeatComplete(4)"
              type="button"
            >
              <span
                class="Button-lit"
                v-t="{ path: 'ACTION_CONTINUE'}"
              ></span>
            </button>
          </div>
        </div>

        <div v-if="isActiveStep(4)">
          <h1
            class="Tit Tit--login mt-3 mb-2 pb-1 text-center"
            v-t="{path : 'user_invitation_card_send_address'}"
          ></h1>

          <!-- Card Send address block -->
          <template v-if="userFromTokenIsRegularOrAdmin">
            <div class="input--block input--block--margin  input--block--padded">
              <div class="d-flex flex-row align-items-center justify-content-between h-100">
                <input-radio
                  :id="'card-send-address-company'"
                  :label="'user_invitation_card_send_option_send_to_office'"
                  :labelClass="'input-radio--label'"
                  :value="'CARD_COMPANY_ADDRESS'"
                  :itemValue="cardSendMode"
                  @click="cardSendMode = 'CARD_COMPANY_ADDRESS'"
                ></input-radio>
                <input-radio
                  :id="'card-send-address-company'"
                  :label="'user_invitation_card_send_option_send_to_other'"
                  :labelClass="'input-radio--label'"
                  :value="'CARD_USER_ADDRESS'"
                  :itemValue="cardSendMode"
                  @click="cardSendMode = 'CARD_USER_ADDRESS'"
                ></input-radio>
              </div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="card-address"
                class="form--label u-required"
              >{{$t('ADDRESS').toUpperCase()}}
              </label>
              <div class="Form-field required"><input
                  type="text"
                  v-model="shippingAddress.address"
                  name="card-address"
                  id="'card-address'"
                  :placeholder="$t('ADDRESS_PLACEHOLDER')"
                  :disabled="isSendCardToOffice()"
                  class="Input-text"
                ></div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="card-city"
                class="form--label u-required"
              >{{$t('CITY').toUpperCase()}}
              </label>
              <div class="Form-field required"><input
                  type="text"
                  v-model="shippingAddress.city"
                  name="card-city"
                  id="'card-city'"
                  :placeholder="$t('CITY')"
                  :disabled="isSendCardToOffice()"
                  class="Input-text"
                ></div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="card-zip"
                class="form--label u-required"
              >{{$t('ZIP').toUpperCase()}}
              </label>
              <div class="Form-field required"><input
                  type="text"
                  v-model="shippingAddress.zipCode"
                  name="card-zip"
                  id="'card-zip'"
                  :placeholder="$t('ZIP')"
                  :disabled="isSendCardToOffice()"
                  class="Input-text"
                ></div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="card-state"
                class="form--label u-required"
              >{{$t('STATE').toUpperCase()}}
              </label>
              <div class="Form-field required"><input
                  type="text"
                  v-model="shippingAddress.state"
                  name="card-state"
                  id="'card-state'"
                  :placeholder="$t('STATE')"
                  :disabled="isSendCardToOffice()"
                  class="Input-text"
                ></div>
            </div>
            <div class="input--block input--block--margin input--block--margin--invitation-form input--block--padded">
              <label
                for="card-country"
                class="form--label u-required"
              >{{$t('COUNTRY').toUpperCase()}}
              </label>
              <div class="Form-field required">
                <input-select
                  :dataCollection="countryShippingList"
                  :track-by="'id'"
                  :label="'name'"
                  :value="shippingAddress.country.id"
                  @input="setCountry('shippingAddress.country',$event)"
                  :disabled="isSendCardToOffice()"
                  :placeholder="''"
                  emitFullValue
                >
                </input-select>
              </div>
            </div>
          </template>
          <!-- end block -->

          <div class="d-flex flex-column w-100">
            <div class="p-1 mt-1">
              <button
                class="Button Button--primary w-100"
                :disabled="!canContinue"
                @click.prevent="goStep(5)"
                type="button"
              >
                <span
                  class="Button-lit"
                  v-t="{ path: 'ACTION_CONTINUE'}"
                ></span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="isActiveStep(5)">
          <h1
            class="Tit Tit--login mt-3 mb-2 pb-1 text-center"
            v-t="{path : 'user_invitation_form_accept_terms'}"
          ></h1>
          <div class="form-fields">
            <ul class="terms-list">
              <li
                v-for="userTerm in userTerms"
                :key="userTerm.id"
              >
                <a
                  role="button"
                  :href="userTerm.url"
                  target="_blank"
                  aria-describedby="more info"
                  rel=noopener
                  class="read-link"
                >
                  <svg class="icon">
                    <use xlink:href="#arrow-right" />
                  </svg>
                </a>

                <span v-t="{path: `user_terms_${userTerm.documentType}`}"></span>
                <p
                  class="description"
                  v-t="{path: `user_terms_${userTerm.documentType}_explanation`}"
                ></p>

              </li>
            </ul>

            <div class="mt-4 pb-1">
              <input
                type="text"
                :value="userInvitationData.email"
                class="d-none"
                autocomplete="username"
              >
              <input
                type="password"
                :value="password"
                class="d-none"
                maxlength="48"
                autocomplete="new-password"
              >
              <label
                class="Checkbox accept-terms-checkbox"
                :class="{'SubOpts-itm--selected' : userAcceptTerms}"
              >
                <input
                  class="Checkbox-input"
                  type="checkbox"
                  name="col-otps"
                  @change="handleAcceptTerms()"
                />
                <i
                  class="Checkbox-customIcon d-none"
                  aria-hidden="true"
                ></i>
                <i
                  class="Checkbox-customIcon"
                  aria-hidden="true"
                  :class="{'Checkbox-customIcon--selected' : userAcceptTerms}"
                ></i>
                <div class="terms-and-conditions-input--texts">
                  <label
                    for="userNewTerms"
                    class="terms-and-conditions-input--text separator"
                  >{{$t(`user_terms_accept_label`)}} </label>
                  <template v-for="(userTerm, index) in userTerms">
                    <span :key="userTerm.id">
                      <span
                        v-if="index > 0 && index < userTerms.length && index + 1 < userTerms.length"
                        class="terms-and-conditions-input--text separator"
                      >,</span>
                      <span
                        v-else-if="index + 1 === userTerms.length"
                        class="terms-and-conditions-input--text separator-last"
                      >{{$t('AND')}}</span>
                      <a
                        class="terms-and-conditions-input--text text-primary"
                        :href="userTerm.url"
                        target="_blank"
                        rel=noopener
                      >{{$t(`user_terms_${userTerm.documentType}`)}}</a>
                    </span>
                  </template>
                </div>
              </label>
            </div>

            <div class="d-flex flex-column w-100 pt-2">
              <button
                class="Button Button--primary w-100"
                :disabled="!canContinue"
                :class="{'btn-secondary' : !canContinue}"
                type="submit"
              >
                <span
                  class="Button-lit"
                  v-t="{ path: 'ACTION_ACCEPT'}"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ICONS -->
      <svg display="none">
        <symbol
          width="12"
          height="12"
          viewBox="0 0 12 12"
          id="arrow-right"
        >
          <g
            id="Dashboard"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
          >
            <g
              id="Fuell/User-Onboarding-Step-03"
              transform="translate(-796.000000, -268.000000)"
              stroke="#6B7C8D"
              stroke-width="2"
            >
              <g
                id="Group-3"
                transform="translate(453.000000, 95.000000)"
              >
                <g
                  id="Log-in"
                  transform="translate(25.000000, 0.000000)"
                >
                  <g
                    id="Group-5"
                    transform="translate(0.000000, 170.000000)"
                  >
                    <polyline
                      id="arrow-right"
                      transform="translate(321.000000, 9.000000) rotate(-360.000000) translate(-321.000000, -9.000000) "
                      points="319 14 323 9 319 4"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </symbol>
      </svg>
    </form>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { InputFacade, facade, filter } from 'vue-input-facade'
import InputSelect from '@/components/Commons/Forms/InputSelect'
import InputRadio from '@/components/Commons/Forms/InputRadio'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'

import { segmentTrack } from '@/analytics/segment'
import * as customValidations from '@/utils/customValidations'
const { validationMixin } = require('vuelidate')
const {
  required,
  requiredIf,
  alphaNum,
  numeric,
  sameAs,
  maxLength,
  minLength
} = require('vuelidate/lib/validators')
export default {
  props: {
    userInvitationData: {
      type: Object,
      required: true
    },
    userTerms: {
      type: Array,
      default: () => []
    }
  },
  mixins: [validationMixin],
  components: {
    InputSelect,
    InputFacade,
    InputRadio,
    DatePickerInput

  },
  directives: { facade },
  filters: { facade: filter },
  data () {
    return {
      isAccountHolder: false,
      password: '',
      firstName: '',
      lastName: '',
      repeatPassword: '',
      userPasscode: null,
      userPasscodeRepeat: null,
      userDocument: '',
      userDocumentExpirationDate: '',
      userPhonePrefix: '',
      userPhone: '',
      userAcceptTerms: false,
      userCountry: '',
      userDateOfBirth: '',
      // userNationality: '',
      /* Card Sending specific data */
      cardSendMode: 'CARD_COMPANY_ADDRESS',
      shippingAddress: {
        address: '',
        city: '',
        zipCode: '',
        state: '',
        country: {}

      },
      step: 1,
      publicFolder: process.env.BASE_URL,
      currentOnboardingSteps: []
    }
  },
  computed: {
    invitationToken () {
      return this.$route.params.token ? this.$route.params.token : false
    },
    phonePrefixList () {
      return this.$store.getters['ConfigStore/publicConfig'].countries.filter(el => el.phonePrefixEnabled) || []
    },
    countryNationalityList () {
      return this.$store.getters['ConfigStore/publicConfig'].countries.filter(el => el.nationalityEnabled) || []
    },
    countryShippingList () {
      return this.$store.getters['ConfigStore/publicConfig'].countries.filter(el => el.shippingAddressEnabled) || []
    },
    countryDocumentMask () {
      const country = this.phonePrefixList.find(el => (el.id === Number.parseInt(this.userCountry) || (el.id === Number.parseInt(this.userCountry.id))))
      let { isoCode: countryIsoCode } = country
      let { COUNTRY_VALIDATION_LIST } = customValidations
      let countryForInputMask = COUNTRY_VALIDATION_LIST.find(el => el.isoCode === countryIsoCode)
      let mask = countryForInputMask ? countryForInputMask.mask : false
      return mask ? [`${mask}`] : null
    },
    selectedCountryHasDocumentValidationRule () {
      const country = this.phonePrefixList.find(el => (el.id === Number.parseInt(this.userCountry) || (el.id === Number.parseInt(this.userCountry.id))))
      if (country) {
        let { isoCode: countryIsoCode } = country
        let { COUNTRY_VALIDATION_LIST } = customValidations

        let countryForValidationRule = COUNTRY_VALIDATION_LIST.find(el => el.isoCode === countryIsoCode)
        let validationRule = countryForValidationRule ? countryForValidationRule.validationRule : false
        return validationRule || false
      }
      return false
    },

    userFromTokenIsRegularOrAdmin () {
      if (this.userInvitationData && this.userInvitationData.roles) {
        return (
          this.userInvitationData.roles.some(el => ['ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_ADMIN', 'ROLE_REGULAR'].includes(el)))
      }
      return false
    },
    userFromTokenHasCards () {
      return this.userInvitationData?.userCardsType === 'USER_CARDS_ALWAYS'
    },
    userFromTokenIsAccountHolder () {
      return this.userInvitationData?.roles.includes('ROLE_ACCOUNT_HOLDER')
    },
    isCallingLogin () {
      return this.$store.getters['LoginStore/isCallingLogin']
    },
    canContinue () {
      return !this.$v.$invalid && !this.isCallingLogin
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    userCardType () {
      if (this.userFromTokenIsRegularOrAdmin) {
        return this.userInvitationData.typeOfCardWhenRegisteredOnIssuer
      }
      return false
    },
    userRoles () {
      return this.userInvitationData?.roles
    },
    userHasVirtualCards () {
      if (this.userCardType) {
        return this.userCardType === 'VIRTUAL'
      }
      return false
    },
    userCanIndicateCardShipping () {
      return this.userInvitationData?.office?.sendCardToOffice === false
    },
    onboardingSteps () {
      return [
        { id: 1, name: 'register', for: 'ALL_USERS' },
        { id: 2, name: 'identification', for: 'CARD_USERS', role_requested: 'ROLE_ACCOUNT_HOLDER' },
        { id: 3, name: 'pin', for: 'ALL_USERS' },
        { id: 4, name: 'address', for: 'CARD_USERS', needs_shipping: true },
        { id: 5, name: 'tos', for: 'ALL_USERS' }
      ]
    }

  },
  methods: {
    handleKeyDown (event) {
      const { keyCode } = event
      if (!this.isNumber(keyCode) && keyCode !== 8) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    setUserDateOfBirth (event) {
      this.userDateOfBirth = event
    },
    isNumber (code) {
      return (code >= 48 && code <= 57) || (code >= 96 && code <= 105)
    },
    generateOnboardingSteps () {
      let steps = []

      this.onboardingSteps.forEach(el => {
        if (el.for === 'ALL_USERS') {
          steps.push(el)
        }

        if (el.for === 'CARD_USERS') {
          if (this.userFromTokenHasCards || (el.role_requested && this.userRoles.some(role => el.role_requested === role))) {
            if (el?.needs_shipping) {
              if (!this.userHasVirtualCards && this.userCanIndicateCardShipping) {
                steps.push(el)
              }
            } else {
              steps.push(el)
            }
          }
        }
      })
      steps.forEach((el, index) => {
        el.step = index + 1
        el.internalId = index + '-step'
        el.separatorId = index + '-separator'
      })
      this.currentOnboardingSteps = [...steps]
    },
    async acceptInvitation () {
      if (!this.userInvitationData && this.isCallingLogin) return

      const userInvitation = {}

      if (this.invitationToken) {
        userInvitation.token = this.invitationToken.trim()
      }

      /** Step 1 info **/
      if (this.firstName) {
        userInvitation.firstName = this.firstName
      }
      if (this.lastName) {
        userInvitation.lastName = this.lastName
      }
      if (this.shippingAddress && this.shippingAddress.address && this.userFromTokenHasCards) {
        userInvitation.shippingAddress = {}
        for (var key in this.shippingAddress) {
          if (this.shippingAddress.hasOwnProperty(key)) {
            if (key === 'country') {
              userInvitation.shippingAddress['country'] = { id: this.shippingAddress['country'].id }
            } else {
              userInvitation.shippingAddress[key] = this.shippingAddress[key]
            }
          }
        }
      }

      if (this.userPhonePrefix && !this.userPhonePrefix.id) {
        userInvitation.phonePrefix = {
          id: Number.parseInt(this.userPhonePrefix)
        }
      } else {
        userInvitation.phonePrefix = {
          id: Number.parseInt(this.userPhonePrefix.id)
        }
      }
      if (this.userCountry && !this.userCountry.id) {
        userInvitation.country = {
          id: Number.parseInt(this.userCountry)
        }
      } else {
        userInvitation.country = { id: Number.parseInt(this.userCountry.id) }
      }

      // if (this.userNationality) {
      //   userInvitation.nationality = { id: Number.parseInt(this.userNationality) }
      // }
      if (this.userPhone) {
        userInvitation.phone = this.userPhone
      }

      if (this.password) {
        userInvitation.password = this.password
      }
      if (this.userDateOfBirth) {
        userInvitation.dateOfBirth = this.userDateOfBirth
      }

      /** Step 2 info **/
      if (this.userDocument) {
        userInvitation.document = this.userDocument.toLowerCase()
      }
      if (this.userDocumentExpirationDate) {
        userInvitation.documentExpirationDate = this.$moment.utc(this.userDocumentExpirationDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      } else {
        userInvitation.documentExpirationDate = this.$moment.utc('01/01/9999', 'DD/MM/YYYY').format('YYYY-MM-DD')
      }

      /** Step 3 info **/
      if (this.userPasscode) {
        userInvitation.passcode = this.userPasscode
      }

      /** Step 5 info **/
      if (this.userAcceptTerms) {
        userInvitation.acceptedPolicy = this.userAcceptTerms
      }
      userInvitation.locale = navigator.language.substring(0, 2)

      try {
        await this.$store.dispatch(
          'LoginStore/acceptInvitation',
          { invitationData: userInvitation, tokenInformation: this.userInvitationData }
        )
      } catch (error) {
        this.cleanUserData()
      }
    },
    cleanUserData () {
      /* If any error should arise while submitting, redirect to first page and touch form
      this.password = ''
      this.repeatPassword = ''
      this.userDocument = ''
      this.userDocumentExpirationDate = ''
      this.userPasscode = ''
      this.userPasscodeRepeat = ''
      this.userPasscodeNotMatch = false
      this.userPasscodeCompleted = false
      this.userDocumentExpirationDate = ''
      this.userPhonePrefix = ''
      this.userPhone = ''
      this.userAcceptTerms = false */
      this.step = 1
      this.$v.$touch()
    },
    setCountry (field, event) {
      this.shippingAddress.country.id = event.id
      this.$v.shippingAddress.country.$touch()
    },
    setField (fieldName, event) {
      if (event && event.target) {
        this[fieldName] = event.target.value
      } else {
        this[fieldName] = event
      }
      this.$v[fieldName].$touch()
    },
    pushSignin () {
      Sentry.setUser(null)
      this.$router.push('/signin')
    },
    isSendCardToOffice () {
      return this.cardSendMode === 'CARD_COMPANY_ADDRESS'
    },
    classForStep (step) {
      return this.step === step ? 'active' : this.step > step ? 'active pass' : ''
    },
    isActiveStep (step) {
      return this.step === step
    },
    handlePasscodeRepeatComplete () {
      if (this.userPasscode === this.userPasscodeRepeat) {
        this.goStep(4)
        segmentTrack('User onboarding passcode created', {
          passcode_created: true
        })
      }
    },
    handleAcceptTerms () {
      this.userAcceptTerms = !this.userAcceptTerms
    },
    goStep (step) {
      if (!this.userFromTokenHasCards || this.isBookKeeper) {
        if (!this.userFromTokenIsAccountHolder) {
          if (step === 2) {
            this.step = 3
            return
          }
        }
        if (step === 4) {
          this.step = 5
          return
        }
      }
      if (this.userHasVirtualCards || !this.userCanIndicateCardShipping) {
        if (step === 4) {
          this.step = 5
          return
        }
      }

      if (!this.userFromTokenIsRegularOrAdmin) {
        if (this.step === 3) {
          this.step = 5
          return
        }
      }
      this.step = step

      if (step === 3) {
        segmentTrack('User onboarding personal ID information provided', {
          invitee_personal_id: this.userDocument
        })
      }
    },
    goPreviousStep (step) {
      if (this.step <= step) return
      this.step = step
    },
    stepOneValidations () {
      let validations = {
        firstName: {
          required,
          latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value)
        },
        lastName: { required, latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value) },

        userPhone: { required, numeric },
        userPhonePrefix: { required },
        userCountry: { required },
        // userNationality: { required },
        userDateOfBirth: { required },
        password: { required, minLength: minLength(6), maxLength: maxLength(48) },
        repeatPassword: { required, maxLength: maxLength(48), minLength: minLength(6), sameAsPassword: sameAs('password') }
      }
      return validations

      /*
      return {
        userInvitationData: {
          firstName: { required,
          latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value) },
          lastName: { required, latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value) }
        },
        userPhone: { required, numeric, minLength: minLength(9), maxLength: maxLength(9) },
        userPhonePrefix: { required },
        password: { required },
        repeatPassword: { sameAsPassword: sameAs('password') },

        shippingAddress: {
          address: { required },
          city: { required },
          zipCode: { required },
          state: { required },
          country: { required }

        }

      } */
    },
    stepTwoValidations () {
      let validations = {}

      if (this.selectedCountryHasDocumentValidationRule) {
        validations = {
          userDocumentExpirationDate: {
            dateIsValid: (value) => {
              if (value) { return this.$moment.utc(value, 'DD/MM/YYYY').isValid() && this.$moment.utc(value, 'DD/MM/YYYY').isAfter() } else { return true }
            }
          },
          userDocument: {
            required,
            alphaNum,
            validDocument: (value) => this.selectedCountryHasDocumentValidationRule(value)
          }
        }
      } else {
        validations = {
          userDocumentExpirationDate: {
            dateIsValid: (value) => {
              if (value) { return this.$moment.utc(value, 'DD/MM/YYYY').isValid() } else { return true }
            }
          },
          userDocument: {
            required,
            alphaNum
          }
        }
      }

      // let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
      // let nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
      // let nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
      // let str = value.toString().toUpperCase()
      // if (!nifRexp.test(str) && !nieRexp.test(str)) return false
      // let nie = str
      //   .replace(/^[X]/, '0')
      //   .replace(/^[Y]/, '1')
      //   .replace(/^[Z]/, '2')

      // let letter = str.substr(-1)
      // var charIndex = parseInt(nie.substr(0, 8)) % 23
      // if (validChars.charAt(charIndex) === letter) return true

      // return false

      return validations
    },

    stepThreeValidations () {
      return {
        userPasscode: { // 4
          maxLength: maxLength(4),
          minLength: minLength(4),
          required,
          numeric
        },
        userPasscodeRepeat: { // 4
          maxLength: maxLength(4),
          minLength: minLength(4),
          sameAsPasscode: sameAs(function () { return this.userPasscode }),
          numeric,
          required
        }
      }
    },

    stepFourValidations () {
      return {
        cardSendMode: {
          required
        },
        shippingAddress: {
          address: {
            required: requiredIf(() => !this.isSendCardToOffice())
          },
          city: {
            required: requiredIf(() => !this.isSendCardToOffice())
          },
          zipCode: {
            required: requiredIf(() => !this.isSendCardToOffice())
          },
          state: {
            required: requiredIf(() => !this.isSendCardToOffice())
          },
          country: {
            required: requiredIf(() => !this.isSendCardToOffice())
          }
        }
      }
    },
    stepFiveValidations () {
      const isTrue = (v) => v === true
      return {
        userAcceptTerms: {
          isTrue
        }
      }
    },
    _initializeAddress () {
      if (this.cardSendMode === 'CARD_COMPANY_ADDRESS') {
        this.shippingAddress.address = this.userInvitationData?.office?.address
        this.shippingAddress.city = this.userInvitationData?.office?.city
        this.shippingAddress.zipCode = this.userInvitationData?.office?.zipCode
        this.shippingAddress.state = this.userInvitationData?.office?.state
        this.shippingAddress.country.id = this.userInvitationData?.office?.country?.id
      }
    }
  },
  validations () {
    switch (this.step) {
      case 1:
        return this.stepOneValidations()
      case 2:
        return this.stepTwoValidations()
      case 3:
        return this.stepThreeValidations()
      case 4:
        return this.stepFourValidations()
      case 5:
        return this.stepFiveValidations()
    }
  },
  async created () {
    this.firstName = this.userInvitationData.firstName
    this.lastName = this.userInvitationData.lastName
    if (this.userFromTokenIsRegularOrAdmin) {
      await this._initializeAddress()
    }
    const roles = this.userInvitationData.roles
    this.isAccountHolder = roles.some(el => ['ROLE_ACCOUNT_HOLDER'].includes(el))
    this.generateOnboardingSteps()
  },
  watch: {
    cardSendMode: function (newV, oldV) {
      if (newV === 'CARD_COMPANY_ADDRESS') {
        this._initializeAddress()
      }
      if (newV === 'CARD_USER_ADDRESS') {
        for (var key in this.shippingAddress) {
          if (this.shippingAddress.hasOwnProperty(key)) {
            this.shippingAddress[key] = ''
          }
        }
        this.shippingAddress.country = { id: this.phonePrefixList.find(el => el.isoCode === 'ES').id }
      }
    }
  }

}
</script>

<style scoped lang="scss">
.terms-and-conditions-input {
  &--container {
    margin-top: 32px;
    display: flex;
    align-items: center;
  }
  &--texts {
    margin-left: 8px;
  }
  &--text {
    margin: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-body);
    &.separator {
      margin: 0 2px 0 0;
    }
    &.separator-last {
      margin: 0 2px;
    }
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .input--block {
    margin: 10px 20px;
    max-width: 280px;
    width: 280px;
  }
  .input--block--smaller {
    margin: 10px 0 10px 20px;
  }
  .input--block--prefix {
    width: 80px !important;
  }
  .input--block--phone {
    width: 160px !important;
    margin: 10px 20px 10px 10px;
  }
  .Form-field {
    margin: 0px;
  }
  .password--mismatch-text {
    margin: 10px 45px;
  }
  .p--sub {
    margin: -15px 20px 0;
  }
  .step-separator {
    width: 45px !important;
  }
  .p--tip {
    padding: 0 6px;
  }
  .terms-list {
    padding: 0 15px !important;
  }
  .Tit--login {
    padding: 0 6px;
  }
  .accept-terms-checkbox {
    margin: 0 20px;
  }
}

@media (max-width: 400px) {
  .passcode-repeat-label {
    padding-bottom: 66px !important;
  }
}

.form-fields {
  max-width: 325px;
  margin: 0 auto;
}

.steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.step {
  font-weight: bold;
  font-size: 14px;
  width: 25px;
  height: 25px;
  border-radius: 15px;
  text-align: center;
  color: var(--text-disabled);
  -webkit-text-fill-color: var(--text-disabled);
  opacity: 1;
  border: 2px solid var(--text-disabled);
}

.step-separator {
  height: 2px;
  width: 75px;
  background-color: var(--fill-inactive);
}

.steps.five-steps .step-separator {
  width: 50px;
}

.step-separator.active {
  background-color: var(--text-heading);
}

.step.active {
  color: var(--text-heading);
  border-color: var(--text-heading);
}

.step.pass {
  background-color: var(--text-heading);
  border-color: var(--text-heading);
  color: var(--text-disabled);
  -webkit-text-fill-color: var(--text-disabled);
  opacity: 1;
}

.step-description {
  color: var(--gray);
  line-height: 1.8em;
  font-size: 0.92em;
  text-align: center;
  font-weight: 300;
}

.step-description strong {
  font-weight: bold;
}

.terms-list {
  list-style-type: none;
  padding: 0;
  margin: 6px 2px 0;
}

.terms-list li {
  padding: 20px 0;
  margin-bottom: 1px;
  position: relative;
}

.terms-list li .description {
  margin-bottom: 0;
  margin-right: 40px;
  font-weight: 300;
  color: var(--gray);
  font-size: 0.9em;
}

.terms-list li .read-link {
  position: absolute;
  width: 12px;
  height: 12px;
  top: 25px;
  right: 10px;
}

.terms-list li .read-link svg {
  width: 100%;
  height: 100%;
}

.checkbox-label {
  font-size: 13px;
  line-height: 1.2em;
  font-weight: 300;
  color: var(--gray);
}

.validation-error {
  font-size: 0.8em;
  padding: 5px 5px 0;
  margin-bottom: 0;
}

.passcode-repeat-label {
  padding-bottom: 21px;
}

.Checkbox-customIcon {
  flex-shrink: 0;
}
</style>

<style>
/* This goes in a separete style tag because it can't be scoped */
.terms-links {
  color: var(--blue-action-1-active);
}
</style>
